module.exports = __webpack_public_path__ + "img/bmcl_gallery19.652ff4e9.jpg";